"use strict";

exports.__esModule = true;

exports.default = function (string, suffix) {
  return string.substr(-suffix.length) === suffix;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/polished/lib/internalHelpers/_endsWith.js
// module id = 3987
// module chunks = 168707334958949